import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';



@Injectable({
  providedIn: 'root'
})
export class RegistrationService {
   
   end_ponits = '';
   _url = '';
  _url_2 = '';
  _url_3 = '';
  _url_4 = '';
  _url_5 = '';
  _url_6 = '';
  _url_7 = '';
  _url_8 = '';
  _url_9 = '';
  _url_10 = '';
  _url_11  = '';
  _url_12  = '';
  _url_13  = '';
  _url_14  = '';
  _url_15   = '';
  _url_16   = '';
  _url_17   = '';
  _url_18   = '';
  _url_19   = '';
  _url_20   = '';
  _url_21   = '';
  _url_22   = '';
  constructor(private _http:HttpClient) { 
    if(location.hostname == 'localhost' || location.hostname == 'uat.mychoize.com'){
      //this.end_ponits = "https://hub.orixindia.com/orix_admin/apis/";
      this.end_ponits = "http://localhost/maruti_subs_admin/apis/";
      
     }else if(location.hostname == '188.166.250.62'){
      this.end_ponits = "http://188.166.250.62/maruti_subs_admin/apis/";
     }else if(location.hostname == '125.22.59.133'){
      this.end_ponits = "http://staging.mychoize.in/maruti_subs_admin/apis/";
     }else if(location.hostname == '125.22.59.134' || location.hostname == 'subscription.orixindia.com'){
      this.end_ponits = "https://hub.orixindia.com/orix_admin/apis/";
     }


   this.end_ponits = "https://hub.orixindia.com/take_a_break_api_php/apis/"; 
  
  this._url    = this.end_ponits+"createSubscription?api_key=ORIX_12345";
  this._url_2  = this.end_ponits+"getVehicleList?api_key=ORIX_12345";
  this._url_3  = this.end_ponits+"getVehicleVarientList?api_key=ORIX_12345";
  this. _url_4 = this.end_ponits+"getVehicleColorList?api_key=ORIX_12345";
  this._url_5  = this.end_ponits+"getTenureList?api_key=ORIX_12345";
  this._url_6  = this.end_ponits+"getEntity?api_key=ORIX_12345";
  this._url_7  = this.end_ponits+"getSource?api_key=ORIX_12345";
  this._url_8  = this.end_ponits+"getMaritalStatus?api_key=ORIX_12345";
  this._url_9  = this.end_ponits+"sendOtpToCustomer?api_key=ORIX_12345";
  this._url_10 = this.end_ponits+"getVarientByChannel?api_key=ORIX_12345";
  this._url_11 = this.end_ponits+"geMyModelVarient?api_key=ORIX_12345";
  this._url_12 = this.end_ponits+"getState?api_key=ORIX_12345";
  this._url_13 = this.end_ponits+"getCity?api_key=ORIX_12345";
  this._url_14  = this.end_ponits+"getDealers?api_key=ORIX_12345";
  this._url_15  = this.end_ponits+"saveContactUsForm?api_key=ORIX_12345";
  this._url_16 =   this.end_ponits+"getContactCity?api_key=ORIX_12345";
  this._url_17 =   this.end_ponits+"getVoCity?api_key=ORIX_12345";
  this._url_18   = this.end_ponits+"getTabCars?api_key=ORIX_12345";
  this._url_19   = this.end_ponits+"getTimeArray?api_key=ORIX_12345";
  this._url_20   = this.end_ponits+"getTbNewCity?api_key=ORIX_12345";
  this._url_21   = this.end_ponits+"getEndTime?api_key=ORIX_12345";
  this._url_22   = this.end_ponits+"getDemoCity?api_key=ORIX_12345";
  }
  saveCustomerInfoToServer(user_data) {
       // it is working fine
      return this._http.post<any>(this._url,user_data);
  }

  getVName(){
     return  this._http.get<any>(this._url_2);
  }

  

  getVrName(){
       return this._http.get<any>(this._url_3);
  }
  getVcName(){
    return this._http.get<any>(this._url_4);
   }

   getTenure(){
      return this._http.get<any>(this._url_5);
   }
   getEntity(){
    return this._http.get<any>(this._url_6);
   }
   getSource(){
    return this._http.get<any>(this._url_7);
   }
   getMarital(){
         return this._http.get<any>(this._url_8);
   }

   sendOTPToCustomer(mobile){
    return this._http.post<any>(this._url_9,mobile);
   }

   geMyVarient(channel_id){
      return this._http.post<any>(this._url_10,channel_id);
   }
   geMyModelVarient(form_data){
      
      return this._http.post<any>(this._url_11,form_data);
   }
   getStateService(){ 
      return  this._http.get<any>(this._url_12);
     }
     getCityService(){
      return  this._http.get<any>(this._url_13);
     }

     onCityChangeService(state_id){
      return  this._http.post<any>(this._url_13,state_id);
     }

     getDealerService(){
       return this._http.get<any>(this._url_14);
     }

     getCityBasedBasedDealers(form_data){
      return this._http.post<any>(this._url_14,form_data);
     }
     saveContactUsForm(form_data){
      return this._http.post<any>(this._url,form_data);
     }
     
     getCityServiceContactUs(){
          return  this._http.get<any>(this._url_16);
     }
     getCityServiceVo(){
      return  this._http.get<any>(this._url_17);
     }
     getCityServiceTab(){
      return  this._http.get<any>(this._url_18);
     }
     getTimeArray(){
      return  this._http.get<any>(this._url_19);
     }
     getEndTime(time_data){
      return  this._http.post<any>(this._url_21,time_data);
     }
     
     getTbNewCity(){
      return  this._http.get<any>(this._url_20);
     }
     getDemoCity(){
      return  this._http.get<any>(this._url_22);
     }


     
     
     
     
}
